import React, { memo } from "react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/bundle";
import * as Styled from "./ImageSlider.style";
import { Props } from "./types";

export const ImageSlider = memo(
    ({ sliderImages }: Props) => {
        return (
            <Styled.ReactSwiper
                pagination={true}
                autoplay={{ delay: 5000 }}
                modules={[Pagination, Autoplay]}
                slidesPerView={3}
                spaceBetween={40}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                    },
                    375: {
                        slidesPerView: 1,
                    },
                    425: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 1,
                    },
                    1024: {
                        slidesPerView: 1,
                    },
                    1440: {
                        slidesPerView: 1,
                    },
                }}
            >
                {sliderImages.map(
                    ({ imgUrl, imgGradient, imgPosition, description }) => (
                        <Styled.ReactSwiperSlider key={imgUrl}>
                            <Styled.ReactSwiperSliderCard
                                img={imgUrl}
                                imgGradient={imgGradient}
                                imgPosition={imgPosition}
                            >
                                <Styled.Text>{description}</Styled.Text>
                            </Styled.ReactSwiperSliderCard>
                        </Styled.ReactSwiperSlider>
                    )
                )}
            </Styled.ReactSwiper>
        );
    }
);
